<template>
	<vendor-page-template>
		<agent-login-window/>
	</vendor-page-template>
</template>
<script>
import AgentLoginWindow from './AgentLoginWindow'
import VendorPageTemplate from '../vendor/VendorPageTemplate'

export default {
	components: {
		VendorPageTemplate,
		AgentLoginWindow
	}
}
</script>
